/**
 * Utilitario de formatacao de precos para o cardapio digital.
 * Centraliza a logica de formatacao que era duplicada em 5+ componentes.
 */

/**
 * Formata um valor numerico como moeda usando Intl.NumberFormat.
 * @param valor - Valor numerico a formatar
 * @param moedaSimbolo - Codigo da moeda (ex: 'BRL', 'PYG', 'USD')
 * @param moedaLocal - Locale para formatacao (ex: 'pt-BR', 'es-PY')
 * @returns String formatada (ex: 'R$ 10,00', 'Gs. 50.000')
 */
export function formatarPreco(valor: number, moedaSimbolo: string, moedaLocal: string): string {
  try {
    return new Intl.NumberFormat(moedaLocal, {
      style: 'currency',
      currency: moedaSimbolo
    }).format(valor);
  } catch {
    return `${moedaSimbolo} ${valor.toFixed(2)}`;
  }
}
